<template>
  <header class="p-3">
    <div class="media align-items-center">
      <div v-if="url" :class="['rounded-circle d-flex justify-content-center align-items-center mr-2', $style.profile]">
      <img
        :src="url"
        width="16"
        height="16"
        class="rounded-circle"
      />
      </div>
      <div class="media-body d-flex justify-content-between">
        <h3 class="mb-0">{{ title }}</h3>
        <slot name="action"></slot>
      </div>
    </div>
    <slot name="description"></slot>
  </header>
</template>

<script>
import AuthMixin from '@/components/mixins/auth'

export default {
  mixins: [AuthMixin],

  props: {
    title: {
      type: String,
      default: null,
    },
    url: {
      type: String,
      default: null,
    },
  },
}
</script>

<style lang="scss" module>
.profile {
  width: 20px;
  height: 20px;
  background: var(--bg-3);
  box-shadow: 0px 1px 4px var(--bg-1);
}
</style>
